import { useOnboardingPopup } from '#layers/access/public';
import { defineFeatureTrigger } from '#layers/base/public';

export function useStudioFeatureTriggers() {
	const { restart: restartOnboardingPopup } = useOnboardingPopup();

	defineFeatureTrigger('onboarding-popup', {
		title: 'Restart onboarding popup',
		description: 'Clears the onboarding checklist and opens the popup',
		onTrigger: restartOnboardingPopup,
	});
}
